import React, { useState } from 'react'
import { ArrowLeft } from 'react-feather'

import { SlideUpPopover } from '@frame/ui-components/slide-up-popover'
import { Button } from '@frame/ui-primitives/button'
import { H3 } from '@frame/ui-primitives/h3'

import { DataAttribute } from '@frame/types'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirmExit: () => void
  onCancel: () => void
}

export function ConfirmExitUploadPopover({ onClose, isOpen, onConfirmExit, onCancel }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  function clickHandler(handler: () => void) {
    setIsLoading(true)
    handler()
    setIsLoading(false)
  }

  function handleHide() {
    if (!isLoading) {
      onClose()
    }
  }

  return (
    <SlideUpPopover show={isOpen} hide={handleHide}>
      <div className="mb-4 flex items-center space-x-2">
        <Button
          aria-label="Back"
          onClick={onClose}
          Icon={ArrowLeft}
          border={false}
          disabled={isLoading}
          intent="secondary"
        />
        <H3>Are you sure you want to exit?</H3>
      </div>
      <div className="mb-4 font-light text-moss-700">
        <p>Progress will be lost and files will be deleted.</p>
      </div>
      <div className="flex flex-col gap-5" data-cy={DataAttribute.DOCUMENTS_EXIT_UPLOAD_SCREEN_POPOVER}>
        <div className="flex flex-col gap-3">
          <Button
            data-cy={DataAttribute.DOCUMENTS_EXIT_UPLOAD_SCREEN_CONFIRM_BUTTON}
            intent="error"
            disabled={isLoading}
            onClick={() => clickHandler(onConfirmExit)}
          >
            Yes, exit and lose progress
          </Button>
          <Button
            data-cy={DataAttribute.DOCUMENTS_EXIT_UPLOAD_SCREEN_CANCEL_BUTTON}
            intent="secondary"
            disabled={isLoading}
            onClick={() => clickHandler(onCancel)}
          >
            No, go back
          </Button>
        </div>
      </div>
    </SlideUpPopover>
  )
}
